import { render, staticRenderFns } from "./PersonCenter.vue?vue&type=template&id=e72f7370&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./PersonCenter.vue?vue&type=script&lang=js&"
export * from "./PersonCenter.vue?vue&type=script&lang=js&"
import style0 from "./PersonCenter.vue?vue&type=style&index=0&id=e72f7370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72f7370",
  null
  
)

export default component.exports